import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from '@mui/material';

import { NSC_ADDRESS, NSPP_TRAVEL } from '../../../../../../../services/i18n/namespaces';
import AddressFields from '../AddressFields/AddressFields';
import AddressValidator from '../AddressFields/AddressValidator';

export default function PreferredPickupAddress({ preferredPickupAddress, values, errors, actions, readOnly = false }) {
  const { t } = useTranslation();
  const { pickupAddress } = values;
  const { setAddressType, setAddressField, setCountryId, setCity } = actions;

  useEffect(
    function() {
      setAddressType({
        path: 'pickupAddress',
        addressType: preferredPickupAddress?.type || 'PATIENT_HOME_ADDRESS',
        address: preferredPickupAddress,
        initial: true
      });
      AddressValidator.revalidate('pickupAddress');
    },
    [setAddressType, preferredPickupAddress]
  );

  return (
    <Grid
      container
      spacing={3}
      alignItems="center"
      sx={{
        pt: 2,
        backgroundColor: '#ffffff',
        mt: 2,
        borderRadius: '4px',
        border: '1px solid rgba(0, 0, 0, 0.12)',
        padding: '16px'
      }}
    >
      <Grid size={12}>
        <Typography variant="subtitle2">{t(`${NSPP_TRAVEL}:travelRequests.preferredPickupAddress`)}</Typography>
      </Grid>
      <Grid container spacing={3} alignItems="flex-end" size={12}>
        <Grid container spacing={2} alignItems="flex-start" size="grow">
          <Grid sx={{ p: 0, marginLeft: '-12px' }} size={9}>
            <FormControl disabled={readOnly}>
              <RadioGroup
                row
                value={pickupAddress.type}
                onChange={function({ target }) {
                  const payload = { path: 'pickupAddress', addressType: target.value };
                  if (payload.addressType === 'PATIENT_HOME_ADDRESS') {
                    payload.address = { ...preferredPickupAddress, type: target.value };
                  }
                  setAddressType(payload);
                  AddressValidator.revalidate('pickupAddress');
                }}
              >
                <FormControlLabel
                  sx={{ margin: 0 }}
                  value="PATIENT_HOME_ADDRESS"
                  control={<Radio />}
                  label={t(`${NSC_ADDRESS}:home`)}
                />
                <FormControlLabel
                  sx={{ margin: 0 }}
                  value="OTHER"
                  control={<Radio />}
                  label={t(`${NSC_ADDRESS}:other`)}
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid size={3}></Grid>
          <AddressFields
            readOnly={readOnly}
            path="pickupAddress"
            values={values}
            errors={errors}
            setAddressField={setAddressField}
            setCountryId={setCountryId}
            setCity={setCity}
          />
        </Grid>
        <Grid size="auto">
          <TextField
            disabled={readOnly}
            name="pickupAddressComments"
            value={values.pickupAddressComments}
            onChange={actions.handleChange}
            fullWidth
            label={t('comments')}
            multiline
            maxRows={4}
            variant="standard"
            sx={{ minWidth: 300 }}
            slotProps={{
              htmlInput: { maxLength: 100 }
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
